export default __webpack_public_path__ + "static/media/victor.6e9e0d07.jpg";